<template>
	<section class="wrapper">
		<el-drawer v-model="state.drawer" size="40%" :close-on-click-modal="false" footer-class="drawer_footer">
			<template #header><span style="text-align: left;">选择云手机</span></template>
			<div>
				<div class="searchbox" style="text-align: left;">
					<el-autocomplete v-model="state.check_cloud_id" :fetch-suggestions="querySearch"
						popper-class="my-autocomplete" placeholder="请输入云机ID" @select="handleSelect"
						style="width: 240px;">
						<template #default="{ item }: { item: CloudPhone }">
							<div>{{ item.instances.name }}</div>
						</template>
					</el-autocomplete>
					<el-button type="primary" color="#0079f2" :icon="Search" style="margin-left: 20px;">查询</el-button>
					<el-button :icon="Refresh" @click="state.check_cloud_id=''">重置</el-button>
				</div>
				<div class="table_div">
					<el-tabs v-model="state.activeName" class="demo-tabs">
						<el-tab-pane label="全部分组" name="first">
							<el-table :data="state.clouds_list" :header-cell-style="headerRowStyle"
								@selection-change="handleSelectionChange">
								<el-table-column type="selection" width="55" />
								<el-table-column prop="instances.name" label="云机ID" />
								<el-table-column property="instance_name" label="云机名称" />
							</el-table>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
			<template #footer>
				<el-button type="primary" color="#0079f2" size="large" @click="Group_control">开始群控</el-button>
			</template>
		</el-drawer>
		<div class="left_phone">
			<div class="master-phone" v-if="state.master_phone.length>0">
				<div class="master-phone_content">
					<div class="phone_id_div">
						<input id="ime" ref="imeRef" style="position:absolute;top:20%;opacity: 0;"
							:readOnly="!store.state.Phone_Local_keyboard_flag" />
						<p><span>{{state.master_phone[0].instance_name || `云机${state.master_phone[0].id}`}}</span>({{state.master_phone[0].instances.name}})
						</p>
						<el-icon style="cursor: pointer;" size="20" color="#0079f2"
							@click="Copy_text(state.master_phone[0].instances.name)">
							<CopyDocument />
						</el-icon>
					</div>
					<div
						:id="`phone-display-${state.master_phone[0].instances.machine.ip}:${state.master_phone[0].instances.adb_port}`" class="master-phone-view">
					</div>
				</div>
			</div>
			<div>

			</div>
		</div>
		<div class="main_phones">
			<div class="top_btns">
				<div>
					<el-checkbox v-model="store.state.is_sync" label="同步操作"
						@change="store.commit('change_is_sync', $event)" />
					<span>已选中 {{state.checked_phone_list.length}}</span>
					<el-button type="primary" color="#0079f2" @click="state.drawer=true">选择云手机</el-button>
					<!-- 			<el-button type="primary" color="#0079f2">批量输入</el-button>
					<el-button type="primary" color="#0079f2">批量上传</el-button>
					<el-button type="primary" color="#0079f2">视图模式</el-button> -->
				</div>
				<div>
					<!-- <span class="Batch_operations">批量操作</span>
					<el-popover popper-style="padding:0;" placement="bottom">
						<template #reference> <el-button><el-icon>
									<ArrowDown />
								</el-icon></el-button>
						</template>
						<div class="fun_options">
							<p>重启</p>
							<p>恢复出厂设置</p>
							<p>批量启动</p>
							<p>批量停止</p>
							<p>批量加载</p>
							<p>批量ADB</p>
						</div>
					</el-popover> -->
					<el-icon :size="20" style="margin-left: 20px;cursor: pointer;" @click.stop="closeOverlay">
						<Close />
					</el-icon>
				</div>
			</div>
			<div ref="cloudsBoxRef" class="clouds_box" v-if="state.otherphone_list.length>0">
				<div v-for="(cloud_value,index) in state.otherphone_list" :key="cloud_value.id">
					<div class="clouds_id_div">
						<p><span>{{cloud_value.instance_name || `云机${cloud_value.id}`}}</span></p>
						<el-icon style="cursor: pointer;" size="16" color="#0079f2"
							@click="Copy_text(cloud_value.instances.name)">
							<CopyDocument />
						</el-icon>
					</div>
					<div class="slave-screenshot"
						@click="change_master_phone(cloud_value,index)">
						<img
							v-if="getSlaveScreenshotUrl(cloud_value)"
							:src="getSlaveScreenshotUrl(cloud_value)"
							class="slave-screenshot-img"
							alt="slave preview"
							@error="onSlaveScreenshotError" />
						<div v-else class="slave-screenshot-placeholder">加载中...</div>
					</div>
				</div>
			</div>
			<div class="clouds_box" v-else>
				<div></div>
			</div>
			<!-- 从机隐藏 stream host：保留 ws_room/scrcpy 完整握手，画面不显示 -->
			<div class="group-hidden-hosts" aria-hidden="true">
				<div
					v-for="phone in state.otherphone_list"
					:key="`hidden-${phone.id}`"
					:id="`phone-display-${phone.instances.machine.ip}:${phone.instances.adb_port}`"
					class="group-hidden-host"
				></div>
			</div>
			<div class="no_phone" v-if="state.master_phone.length==0 && state.otherphone_list.length==0">
				<div>
					<img src="@/assets/no_group.png" />
					<p>暂无云机</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
	import {
		Ref,
		ref,
		reactive,
		computed,
		onMounted,
		onUnmounted,
		getCurrentInstance,
		nextTick,
		watch
	} from 'vue';
	import {
		Close,
		Search,
		Refresh,
		CopyDocument,
		ArrowDown,
		ArrowUp
	} from '@element-plus/icons-vue';
	import {
		StreamClientScrcpy
	} from '@/app/googDevice/client/StreamClientScrcpy';
	import {
		openCloudPhoneStream
	} from '@/app/streaming/openCloudPhoneStream';
	import request from '@/utils'
	import {
		ElMessage
	} from 'element-plus';
	import {
		useStore
	} from 'vuex';
	import {
		BroadcastService
	} from '@/app/interactionHandler/BroadcastService';
	import { BroadcastBus } from '@/app/interactionHandler/BroadcastBus';
	import { KeyInputHandler, type KeyEventListener } from '@/app/googDevice/KeyInputHandler';

	// 定义类型
	interface Machine {
		id : number;
		ip : string;
		cpu : string;
		cpu_core : number;
		memory : number;
		volume : number;
		status : number;
		created_at : string;
		updated_at : string;
		mac_addr : string;
		volume_device : string;
	}

	interface Instance {
		id : number;
		machine_id : number;
		mac : string;
		ip : string;
		product_id : number;
		package_id : number;
		created_at : string;
		updated_at : string;
		status : number;
		is_realphone : number;
		adb_port : number;
		adb_address : string;
		height : number;
		width : number;
		image : string;
		image_tag : string;
		index : number;
		state : number;
		cpu_cores : number;
		memory : number;
		storage : number;
		name : string;
		machine : Machine;
	}

	interface CloudPhone {
		id : number;
		user_id : string;
		instance_id : number;
		start_time : string;
		expire_time : string;
		status : number;
		created_at : string;
		updated_at : string;
		order_id : number;
		image : string;
		image_tag : string;
		auto_renew : number;
		screen_shot : string;
		instance_name : string;
		instances : Instance;
		checked ?: boolean;
		is_trial ?: number;
		state : number;
		screen_shot_loading ?: boolean;
	}

	interface State {
		master_phone : CloudPhone[];
		drawer : boolean;
		activeName : string;
		check_cloud_id : string | null;
		clouds_list : CloudPhone[];
		otherphone_list : CloudPhone[];
		checked_phone_list : CloudPhone[];
		ws : WebSocket | null;
		StreamClientScrcpy_start : any;
		StreamClientScrcpy_start_list : any[];
		playerRegistrations : any[];
		connections : any;
		udids : any[];
	}

	interface CommitMsg { type : 'commit'; text ?: string; }
	interface DeleteMsg { type : 'delete'; count : number; text ?: string; }
	interface ReplaceMsg { type : 'replace'; text ?: string; }
	type InputMsg = CommitMsg | DeleteMsg | ReplaceMsg;

	const store = useStore();
	const appRouter = getCurrentInstance()?.appContext.config.globalProperties.$router;

	const state = reactive<State>({
		master_phone: [],
		drawer: true,
		activeName: 'first',
		check_cloud_id: null,
		clouds_list: [],
		otherphone_list: [],
		checked_phone_list: [],
		ws: null,
		StreamClientScrcpy_start: null,
		StreamClientScrcpy_start_list: [],
		playerRegistrations: [],
		connections: null,
		udids: []
	});

	onUnmounted(() => {
		disableScreenshotSyncMode();
		BroadcastService.getInstance().unregisterClient();
		clearImeEvents();
	})

	class WebSocketManager {
		private connections : Map<string, any>;
		private players : Map<string, any>;

		constructor() {
			this.connections = new Map();
			this.players = new Map();
		}

		// 建立单个连接
		async connect(
			device : CloudPhone,
			is_tool : boolean,
			ScreenW : number,
			ScreenH : number,
			zoomsize : number,
			bitrate: number,
			is_master_cloud : boolean
		) : Promise<any> {
			try {
				const udid = `${device.instances.machine.ip}:${device.instances.adb_port}`;
				if (!is_master_cloud) {
					// 从机：无论 ws_room 还是 ws_scrcpy，都走完整 openCloudPhoneStream 挂到隐藏 host。
					// 画面在 UI 上不显示（靠 /rtc/update_screenshot_config + 截图 img 替代），
					// 但必须保留 FeaturedInteractionHandler 以订阅 BroadcastBus 接收主控广播。
					await initPlayers(ScreenW, ScreenH, zoomsize, bitrate);
					state.StreamClientScrcpy_start = await openCloudPhoneStream({
						phone: device as any,
						showToolBox: false,
						isMasterCloud: false,
						sourceType: 'group_control',
					});
					state.StreamClientScrcpy_start_list.push(state.StreamClientScrcpy_start);
					BroadcastService.getInstance().registerClient(state.StreamClientScrcpy_start as any);
					console.info(`[groupControl] 从机已建立(隐藏拉流): ${udid} mode=${(state.StreamClientScrcpy_start as any)?.mode}`);
					return state.StreamClientScrcpy_start;
				}
				// 主机：完整拉流 + 工具条
				await initPlayers(ScreenW, ScreenH, zoomsize, bitrate);
				state.StreamClientScrcpy_start = await openCloudPhoneStream({
					phone: device as any,
					showToolBox: is_tool,
					isMasterCloud: is_master_cloud,
					sourceType: 'group_control',
				});
				state.StreamClientScrcpy_start_list.push(state.StreamClientScrcpy_start);
				BroadcastService.getInstance().registerClient(state.StreamClientScrcpy_start as any);
				// 触摸 / 按键 / 滚轮的跨机广播由 FeaturedInteractionHandler 通过 BroadcastBus 完成，
				// 从机端在 handleBroadcastMessage 里按各自 screenInfo 重算坐标，不再需要在这里包装 sendMessage。
				// 这里只挂一个活动回调，用于主控操作时把截图刷新率临时切到 1s。
				(window as any).__onGroupMasterActivity = () => {
					if (state.otherphone_list.length) markSyncOperationActive();
				};
				const player = state.StreamClientScrcpy_start?.getPlayer();
				// 主控启用本地键盘：先 false 再 true 触发 store watch，从而让 bindImeEvents 在 imeRef 已挂载后生效
				try {
					state.StreamClientScrcpy_start?.setHandleKeyboardEvents(false);
					await nextTick();
					setTimeout(() => {
						state.StreamClientScrcpy_start?.setHandleKeyboardEvents(true);
						const checkbox = document.getElementById(`input_capture_keyboard_${udid}_${player?.getName()}`) as HTMLInputElement | null;
						if (checkbox) checkbox.checked = true;
						imeRef.value?.focus();
					}, 300);
				} catch (err) {
					console.warn('[groupControl] 启用主控本地键盘失败:', err);
				}
				return state.StreamClientScrcpy_start;
			} catch (error) {
				console.error(`连接设备 ${device?.instances?.machine?.ip} 失败:`, error);
				throw error;
			}
		}

		async connectMultiple(
			devices : CloudPhone[],
			is_tool : boolean,
			ScreenW : number,
			ScreenH : number,
			zoomsize : number,
			bitrate: number,
			is_master_cloud : boolean
		) : Promise<Array<{ deviceId : string; status : string; player ?: any; error ?: string }>> {
			const results = [];
			for (const item of devices) {
				try {
          let width:number=item.instances.width
          let height:number=item.instances.height
          if (is_master_cloud) {
            width=ScreenW
            height=ScreenH
            bitrate=2388608
          }else{
            width=width*0.2
            height=height*0.2
          }
 					const player = await this.connect(
						item,
						is_tool,
						width,
						height,
						zoomsize,
						bitrate,
						is_master_cloud
					);
					results.push({
						deviceId: item.instances.machine.ip,
						status: 'connected',
						player
					});
				} catch (error : any) {
					results.push({
						deviceId: item.instances.machine.ip,
						status: 'error',
						error: error.message
					});
				}
			}
			return results;
		}

		// 获取所有Player实例（同步方法）
		getAllPlayers() : any[] {
			return Array.from(this.players.values());
		}
	}

	const wsManager = ref<WebSocketManager>(new WebSocketManager());

	// ========== 截图同步（从机不拉流，靠截图展示） ==========
	const SYNC_SCREENSHOT_IDLE_INTERVAL = 3000;
	const SYNC_SCREENSHOT_ACTIVE_INTERVAL = 1000;
	const SYNC_OPERATION_IDLE_TIMEOUT_MS = 20000;
	const slaveScreenshots = ref<Record<number, string>>({});
	const slaveScreenshotBase = ref<Record<number, string>>({});
	const currentScreenshotIntervalMs = ref<number | null>(null);
	const screenshotPollingTimer = ref<ReturnType<typeof setInterval> | null>(null);
	const syncOperationIdleTimer = ref<ReturnType<typeof setTimeout> | null>(null);
	const getFollowerPhoneIds = () : number[] => state.otherphone_list.map((p) => p.id);
	const getSlaveScreenshotUrl = (phone : CloudPhone) : string => {
		return slaveScreenshots.value[phone.id] || '';
	};
	const onSlaveScreenshotError = (e : Event) => {
		const img = e.target as HTMLImageElement;
		if (img) img.src = '';
	};
	const buildScreenshotBase = (raw : string) : string => {
		if (!raw) return '';
		// 去掉旧的 timestamp query，避免越积越长
		const base = raw.includes('?') ? raw.split('?')[0] : raw;
		return base.includes('http') ? base : `${store.state.request_url}${base}`;
	};
	const cacheSlaveScreenshotBases = () => {
		const next : Record<number, string> = {};
		for (const p of state.otherphone_list) {
			if ((p as any).screen_shot) {
				next[p.id] = buildScreenshotBase((p as any).screen_shot);
			}
		}
		slaveScreenshotBase.value = next;
	};
	const updateScreenshotSyncMode = async (enabled : boolean, ids : number[], interval ?: number) => {
		if (!ids.length) return;
		const payload : any = { instance_use_ids: ids, sync_mode: enabled };
		if (enabled) {
			payload.upload_interval = interval ?? SYNC_SCREENSHOT_IDLE_INTERVAL;
			payload.upload_quality = (interval ?? SYNC_SCREENSHOT_IDLE_INTERVAL) <= SYNC_SCREENSHOT_ACTIVE_INTERVAL ? 24 : 28;
			payload.max_long_edge = 420;
		}
		try {
			await request.post('/rtc/update_screenshot_config', payload);
		} catch (error) {
			console.error('更新截图同步配置失败:', error);
		}
	};
	const refreshSlaveScreenshots = () => {
		// 只更新 timestamp 触发浏览器重新取图，不再请求 /containers/list
		if (!state.otherphone_list.length) return;
		const ts = Date.now();
		const next : Record<number, string> = { ...slaveScreenshots.value };
		for (const id of Object.keys(slaveScreenshotBase.value)) {
			const phoneId = Number(id);
			const base = slaveScreenshotBase.value[phoneId];
			if (base) next[phoneId] = `${base}?t=${ts}`;
		}
		slaveScreenshots.value = next;
	};
	const startScreenshotPolling = (intervalMs : number) => {
		stopScreenshotPolling();
		screenshotPollingTimer.value = setInterval(refreshSlaveScreenshots, intervalMs);
		// 立刻刷一次
		refreshSlaveScreenshots();
	};
	const stopScreenshotPolling = () => {
		if (screenshotPollingTimer.value) {
			clearInterval(screenshotPollingTimer.value);
			screenshotPollingTimer.value = null;
		}
	};
	const applyScreenshotInterval = async (intervalMs : number, reason : string) => {
		if (currentScreenshotIntervalMs.value === intervalMs) return;
		currentScreenshotIntervalMs.value = intervalMs;
		const ids = getFollowerPhoneIds();
		if (!ids.length) return;
		await updateScreenshotSyncMode(true, ids, intervalMs);
		startScreenshotPolling(intervalMs);
		console.info(`[groupControl] screenshot interval=${intervalMs}ms reason=${reason}`);
	};
	const clearSyncOperationIdleTimer = () => {
		if (syncOperationIdleTimer.value) {
			clearTimeout(syncOperationIdleTimer.value);
			syncOperationIdleTimer.value = null;
		}
	};
	const markSyncOperationActive = () => {
		if (!state.otherphone_list.length) return;
		applyScreenshotInterval(SYNC_SCREENSHOT_ACTIVE_INTERVAL, 'operation_active');
		clearSyncOperationIdleTimer();
		syncOperationIdleTimer.value = setTimeout(() => {
			applyScreenshotInterval(SYNC_SCREENSHOT_IDLE_INTERVAL, 'operation_idle');
		}, SYNC_OPERATION_IDLE_TIMEOUT_MS);
	};
	const disableScreenshotSyncMode = async () => {
		clearSyncOperationIdleTimer();
		stopScreenshotPolling();
		const ids = getFollowerPhoneIds();
		if (ids.length) {
			try { await updateScreenshotSyncMode(false, ids); } catch (_e) {}
		}
		currentScreenshotIntervalMs.value = null;
		slaveScreenshots.value = {};
		slaveScreenshotBase.value = {};
	};
	// ========== end 截图同步 ==========

	async function Group_control() : Promise<void> {
		if (state.checked_phone_list.length > 0) {
			state.udids = []
			const primaryDevice = state.checked_phone_list[0];
			state.master_phone.push(primaryDevice);
			const hasRemainingDevices = state.checked_phone_list.length > 1;

			if (hasRemainingDevices) {
				state.otherphone_list = state.checked_phone_list.slice(1);
				cacheSlaveScreenshotBases();
				// 等 Vue 渲染出隐藏 host 节点，stream client 才能挂载
				await nextTick();
				await wsManager.value.connectMultiple(state.otherphone_list, false, 1080, 1920, 0.2,1388608,false);
			}

			await wsManager.value.connectMultiple(state.master_phone, true, 1080, 1920, 0.4,5388608, true);
			state.drawer = false;
			// 从机改为截图模式：调 /rtc/update_screenshot_config 开启上传，并以空闲频率启动轮询
			if (hasRemainingDevices) {
				await applyScreenshotInterval(SYNC_SCREENSHOT_IDLE_INTERVAL, 'group_started');
			}
		}
	}

	initdata(); //渲染前执行请求

	function initdata() : void {
		get_clouds();
	}

	function Copy_text(text : string) : Promise<void> {
		if (navigator.clipboard && window.isSecureContext) {
			// navigator clipboard 向剪贴板写文本
			return navigator.clipboard.writeText(text)
		} else {
			// 创建text area
			const textArea = document.createElement('textarea')
			textArea.value = text
			// 使text area不在viewport，同时设置不可见
			document.body.appendChild(textArea)
			textArea.focus()
			textArea.select()
			return new Promise<void>((res, rej) => {
				// 执行复制命令并移除文本框
				document.execCommand('copy') ? res() : rej()
				textArea.remove()
			})
		}
	}

	//获取当前用户的所有云手机
	function get_clouds() : void {
		const response = request.get('/containers/list');
		response.then((res : any) => {
			state.clouds_list = res.data.data;
		}).catch(() => { });
	}

	const headerRowStyle = ({ row, rowIndex } : { row : any; rowIndex : number }) : { [key : string] : string } => {
		return {
			backgroundColor: '#f0f3f5', // 背景色
			color: '#212224', // 文字颜色
		};
	};

	const querySearch = (queryString : string, callback : (results : CloudPhone[]) => void) : void => {
		const results = queryString
			? state.clouds_list.filter(item =>
				item.instances.name.toLowerCase().includes(queryString.toLowerCase())
			)
			: state.clouds_list;
		callback(results); // 返回筛选结果
	};
	//关闭并退出群控页面
	async function closeOverlay() : Promise<void> {
		await disableScreenshotSyncMode();
		BroadcastService.getInstance().unregisterClient()
		appRouter?.back();
	}

	//切换主设备
	const change_master_phone = async (cloud_value : CloudPhone, index : number) : Promise<void> => {
		clearSyncOperationIdleTimer();
		stopScreenshotPolling();
		BroadcastService.getInstance().unregisterClient();
		state.StreamClientScrcpy_start_list = []
		state.udids = []
		const other_phone = JSON.parse(JSON.stringify(state.master_phone[0]));
		state.master_phone[0] = cloud_value;
		state.otherphone_list[index] = other_phone;
		cacheSlaveScreenshotBases();
		await nextTick();
		await wsManager.value.connectMultiple(state.master_phone, true, 1280, 1920, 0.4,5388608,true);
		await wsManager.value.connectMultiple(state.otherphone_list, false, 1280, 1920, 0.2,1388608,false);
		currentScreenshotIntervalMs.value = null;
		await applyScreenshotInterval(SYNC_SCREENSHOT_IDLE_INTERVAL, 'master_switched');
	};

	const handleSelect = (item : CloudPhone) : void => {
		state.check_cloud_id = item.instances.name;
	};

	// 初始化播放器
	const initPlayers = async (ScreenW : number, ScreenH : number, zoomsize : number,bitrate: number) : Promise<void> => {
		const { MsePlayer } = await import('@/app/player/MsePlayer');
		StreamClientScrcpy.registerPlayer(MsePlayer);
		const { WebCodecsPlayer } = await import('@/app/player/WebCodecsPlayer');
		StreamClientScrcpy.registerPlayer(WebCodecsPlayer);
		MsePlayer.resize(ScreenW, ScreenH, zoomsize,bitrate); //改变当前云手机屏幕的宽高和屏幕点击(x,y)缩放的大小
	};

	function handleSelectionChange(val : CloudPhone[]) : void {
		state.checked_phone_list = val;
	}

	const imeRef = ref<HTMLInputElement | null>(null);
	let lastSent = "";
	let isEventsBound = false;
	let keyInputListener : KeyEventListener | null = null;
	let isComposing = ref(false); // 改用ref，确保响应式（之前是普通变量，可能有延迟）

	const currentPhone = ref<CloudPhone | null>(null);
	const showOverlay = ref(true);
	const ws = ref<WebSocket | null>(null);
	// 根据"同步操作"开关返回需要接收文本/按键的目标客户端：同步开 → 全部；同步关 → 只有 master
	const getSyncTargetClients = () : any[] => {
		const clients = state.StreamClientScrcpy_start_list as any[];
		if (store.state.is_sync) return clients;
		if (!state.master_phone[0]?.instances?.machine || !state.master_phone[0]?.instances?.adb_port) {
			return clients;
		}
		const masterUdid = `${state.master_phone[0].instances.machine.ip}:${state.master_phone[0].instances.adb_port}`;
		return clients.filter((c) => c?.getPlayer?.()?.udid === masterUdid);
	};
	// 当前主控客户端（从 StreamClient 列表里按 master udid 定位）
	const getMasterClient = () : any => {
		if (!state.master_phone[0]?.instances?.machine) return null;
		const masterUdid = `${state.master_phone[0].instances.machine.ip}:${state.master_phone[0].instances.adb_port}`;
		return state.StreamClientScrcpy_start_list.find((c : any) => c?.getPlayer?.()?.udid === masterUdid) || null;
	};
	// 广播 IME 文本到从机（PC 的 broadcastImeText 对应实现）
	const broadcastImeText = (text : string) : void => {
		const master = getMasterClient();
		if (!master) return;
		const masterUdid = master.getPlayer?.()?.udid;
		if (!masterUdid) return;
		BroadcastBus.getInstance().emit({
			sourcePhoneId: masterUdid,
			groupId: 'default',
			message: { type: 'ime_text', sourcePhoneId: masterUdid, timestamp: Date.now(), data: { text } },
			timestamp: Date.now(),
		});
		try { (window as any).__onGroupMasterActivity?.(); } catch (_e) {}
	};
	// 广播功能键（Enter/Tab/Arrow...）到从机，从机端 executeKeyEvent → listener.sendKeyEvent(code, action, metaState)
	const broadcastFunctionKey = (code : string, action : 'down' | 'up', metaState : number) : void => {
		const master = getMasterClient();
		if (!master) return;
		const masterUdid = master.getPlayer?.()?.udid;
		if (!masterUdid) return;
		BroadcastBus.getInstance().emit({
			sourcePhoneId: masterUdid,
			groupId: 'default',
			message: {
				type: 'key',
				sourcePhoneId: masterUdid,
				timestamp: Date.now(),
				data: { code, action, metaState },
			},
			timestamp: Date.now(),
		});
		try { (window as any).__onGroupMasterActivity?.(); } catch (_e) {}
	};

	//中文和粘贴广播内容
	function sendMsg(msg : InputMsg) : void {
		if (!state.master_phone[0].id) return;
		const clients = getSyncTargetClients();
		const wsRoomClients = clients.filter((c) => c?.mode === 'ws_room');
		const scrcpyClients = clients.filter((c) => c?.mode !== 'ws_room');
		// ws_room 客户端：通过 WebSocket 直接下发 IME / 退格，不走 HTTP
		if (wsRoomClients.length) {
			wsRoomClients.forEach((c) => {
				if (msg.type === 'delete') {
					const count = Math.max(1, (msg as DeleteMsg).count || 1);
					for (let i = 0; i < count; i++) {
						c.sendBackspaceKey?.();
					}
				} else if (msg.text) {
					c.sendImeText?.(msg.text);
				}
			});
		}
		if (!scrcpyClients.length) {
			if (!isComposing.value) {
				KeyInputHandler.setWebSocketEnabled(true);
			}
			return;
		}
		state.udids = scrcpyClients.map((c) => c.getPlayer()?.udid).filter(Boolean);
		const requestData = { udids: state.udids, text: msg.text };
		request.post('/containers/batch_transfer_text', requestData).then(() => {
			if (!isComposing.value) {
				KeyInputHandler.setWebSocketEnabled(true);
			}
		}).catch(() => { });
	}

	// 初始化时设为false，避免初始状态异常
	const handleCompositionStart = (e : Event) : void => {
		const ev = e as CompositionEvent;
		isComposing.value = true;
		KeyInputHandler.setWebSocketEnabled(false);
		e.stopImmediatePropagation();
		e.preventDefault();
	};

	const handleCompositionEnd = (e : Event) : void => {
		const ev = e as CompositionEvent;
		const chineseText = ev.data?.trim();
		setTimeout(() => {
			isComposing.value = false;
			KeyInputHandler.setWebSocketEnabled(true);
		}, 100); // 延迟100ms，避免选字后立即触发英文输入
		if (chineseText && store.state.Phone_Local_keyboard_flag && imeRef.value) {
			const msg : CommitMsg = { type: 'commit', text: chineseText };
			sendMsg(msg);
			imeRef.value.value = "";
			lastSent = "";
		}
	};

	// 修改 handleInput - 处理英文字符输入
	const handleInput = (e : Event) : void => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		const inputEvent = e as InputEvent;
		const newValue = imeRef.value.value;

		if (isComposing.value) return;
		if (newValue.length > lastSent.length) {
			const newChars = newValue.slice(lastSent.length);
			const master = getMasterClient();
			const masterIsWsRoom = master?.mode === 'ws_room';

			for (const char of newChars) {
				// 特殊符号 ?/ 统一走 transfer_text
				if (char === '?' || char === '/') {
					sendSymbolAsText(char);
					continue;
				}
				if (char >= ' ' && char <= '~') {
					// 主控本机执行
					if (masterIsWsRoom) {
						master?.sendImeText?.(char);
					} else if (master) {
						// ws_scrcpy master：走 KeyInputHandler（仅主控订阅此 handler）→ 会命中 Gboard，同 PC 行为
						KeyInputHandler.sendCharacter(char);
					}
					// 同步从机：通过 BroadcastBus 发 ime_text，ws_room 从机走 sendImeText，ws_scrcpy 从机走 /containers/transfer_text
					if (store.state.is_sync) {
						broadcastImeText(char);
					}
				}
			}
			lastSent = newValue;
		} else if (newValue.length < lastSent.length) {
			lastSent = newValue;
		}
	};

	// 👇 新增：直接发送 ?/ 到云手机输入框（复用中文输入的文本接口）
	const sendSymbolAsText = (symbol : string) : void => {
		const clients = getSyncTargetClients();
		const wsRoomClients = clients.filter((c) => c?.mode === 'ws_room');
		const scrcpyClients = clients.filter((c) => c?.mode !== 'ws_room');
		if (wsRoomClients.length) {
			wsRoomClients.forEach((c) => c.sendImeText?.(symbol));
		}
		if (!scrcpyClients.length) return;
		if (!currentPhone.value?.instances?.machine || !currentPhone.value?.instances?.adb_port) {
			ElMessage.error('云手机信息不完整，无法发送符号');
			return;
		}
		const currentPhoneUdid = `${currentPhone.value.instances.machine.ip}:${currentPhone.value.instances.adb_port}`;
		const requestData = {
			udid: currentPhoneUdid,
			text: symbol
		};
		request.post('/containers/transfer_text', requestData)
			.then(() => { })
			.catch(() => { });
	};

	// 修改 handleKeyDown 方法，添加 CapsLock 处理
	const handleKeyDown = (e : KeyboardEvent) : void => {
		if (!store.state.Phone_Local_keyboard_flag || isComposing.value) return;

		// 👇 新增：处理 CapsLock 键按下
		if (e.key === 'CapsLock') {
			e.preventDefault(); // 阻止浏览器默认行为（避免本地输入法干扰）
			KeyInputHandler.sendKeyEvent(e.code, 'down', 0); // metaState=0（无需修饰键）
			return;
		}

		// 原有退格键处理
		if (e.key === 'Backspace') {
			e.preventDefault();
			const master = getMasterClient();
			const masterIsWsRoom = master?.mode === 'ws_room';
			// 主控本机执行
			if (masterIsWsRoom) {
				master?.sendBackspaceKey?.();
			} else if (master) {
				KeyInputHandler.sendBackspaceKey();
			}
			// 同步从机
			if (store.state.is_sync) {
				const master = getMasterClient();
				const masterUdid = master?.getPlayer?.()?.udid;
				if (masterUdid) {
					BroadcastBus.getInstance().emit({
						sourcePhoneId: masterUdid,
						groupId: 'default',
						message: {
							type: 'button_key_event',
							sourcePhoneId: masterUdid,
							timestamp: Date.now(),
							action: 0, keycode: 67, metaState: 0, repeat: 0,
						},
						timestamp: Date.now(),
					});
					BroadcastBus.getInstance().emit({
						sourcePhoneId: masterUdid,
						groupId: 'default',
						message: {
							type: 'button_key_event',
							sourcePhoneId: masterUdid,
							timestamp: Date.now(),
							action: 1, keycode: 67, metaState: 0, repeat: 0,
						},
						timestamp: Date.now(),
					});
				}
			}
			return;
		}

		// 其他功能键（保留原有）
		const functionKeys = [
			'Enter', 'Tab', 'Escape', 'ArrowUp', 'ArrowDown',
			'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
		];

		if (functionKeys.includes(e.key)) {
			e.preventDefault();
			const metaState = e.shiftKey ? 1 : 0;
			KeyInputHandler.sendKeyEvent(e.code, 'down', metaState);
			if (store.state.is_sync) broadcastFunctionKey(e.code, 'down', metaState);
		}
	};

	// 修改 handleKeyUp 方法，添加 CapsLock 处理
	const handleKeyUp = (e : KeyboardEvent) : void => {
		if (isComposing.value || !store.state.Phone_Local_keyboard_flag) {
			e.stopPropagation();
			e.preventDefault();
			return;
		}

		// 👇 新增：处理 CapsLock 键释放
		if (e.key === 'CapsLock') {
			e.preventDefault();
			KeyInputHandler.sendKeyEvent(e.code, 'up', 0); // metaState=0
			return;
		}

		// 其他功能键（保留原有）
		const functionKeys = [
			'Enter', 'Tab', 'Escape', 'ArrowUp', 'ArrowDown',
			'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
		];

		if (functionKeys.includes(e.key)) {
			e.preventDefault();
			const metaState = e.shiftKey ? 1 : 0;
			KeyInputHandler.sendKeyEvent(e.code, 'up', metaState);
			if (store.state.is_sync) broadcastFunctionKey(e.code, 'up', metaState);
		}
	};

	const handlePaste = (e : Event) : void => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		const ev = e as ClipboardEvent;
		ev.preventDefault();
		const pastedText = ev.clipboardData?.getData('text');
		if (pastedText) {
			const msg : CommitMsg = { type: 'commit', text: pastedText };
			sendMsg(msg);
			imeRef.value.value = "";
		}
	};

	const handleFocus = (e : Event) : void => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		lastSent = imeRef.value.value;
	};

	const handleBlur = (e : Event) : void => {
		isComposing.value = false;
		KeyInputHandler.setWebSocketEnabled(true);
	};

	const bindImeEvents = () : void => {
		const inp = imeRef.value;
		if (!inp || !store.state.Phone_Local_keyboard_flag || isEventsBound) return;
		inp.addEventListener('input', handleInput);
		inp.addEventListener('keydown', handleKeyDown); // 捕获阶段拦截
		inp.addEventListener('compositionstart', handleCompositionStart);
		inp.addEventListener('compositionend', handleCompositionEnd);
		inp.addEventListener('keyup', handleKeyUp);
		inp.addEventListener('paste', handlePaste);
		inp.addEventListener('focus', handleFocus);
		inp.addEventListener('blur', handleBlur);
		keyInputListener = {
			onKeyEvent: (message) => {
				if (ws.value && ws.value.readyState === WebSocket.OPEN) {
					ws.value.send(JSON.stringify(message));
				}
			}
		};
		KeyInputHandler.addEventListener(keyInputListener);
		isEventsBound = true;
		inp.focus();
		setTimeout(() => inp.focus(), 100);
	};

	const clearImeEvents = () : void => {
		const inp = imeRef.value;
		if (!inp || !isEventsBound) return;
		inp.removeEventListener('keydown', handleKeyDown);
		inp.removeEventListener('input', handleInput);
		inp.removeEventListener('compositionstart', handleCompositionStart);
		inp.removeEventListener('compositionend', handleCompositionEnd);
		inp.removeEventListener('keyup', handleKeyUp);
		inp.removeEventListener('paste', handlePaste);
		inp.removeEventListener('focus', handleFocus);
		inp.removeEventListener('blur', handleBlur);
		if (keyInputListener) {
			KeyInputHandler.removeEventListener(keyInputListener);
			keyInputListener = null;
		}

		isEventsBound = false;
		isComposing.value = false;
		lastSent = "";
		inp.value = "";
	};
	// 合并两个 watch 监听器
	watch(() => store.state.Phone_Local_keyboard_flag, (isEnabled) => {
		const inp = imeRef.value;

		if (isEnabled && showOverlay.value) {
			bindImeEvents();
		} else {
			// 执行两个 else 分支的逻辑
			clearImeEvents();
			if (inp) {
				inp.value = "";
				isComposing.value = false;
				KeyInputHandler.setWebSocketEnabled(true);
			}
		}
	}, { immediate: true });
</script>

<style lang="less" scoped>
	.table_div {
		padding: 20px;
		margin-top: 20px;
		border: 1px solid #e5e8ee;
		border-radius: 5px;
	}

	.clouds_box {
		height: calc(100% - 50px);
		overflow-y: auto;
		overflow-x: hidden;
		width: 100%;
		padding: 20px;
		display: flex;
		justify-content: left;
		align-items: center;
		flex-wrap: wrap;
		gap: 20px;
		box-sizing: border-box;

		.phone-display {
			// zoom: 0.2;
		}

		div {
			width: initial !important;
			height: initial !important;
		}

		// 覆盖上面 `div { width/height: initial !important }`，保证从机截图卡片尺寸可控
		.slave-screenshot {
			width: 180px !important;
			height: 320px !important;
		}
		.slave-screenshot-placeholder {
			width: 100% !important;
			height: 100% !important;
		}
	}

	.drawer_footer {
		text-align: center;

		button {
			padding: 20px 70px;
		}
	}

	button {
		border-radius: 8px;
	}

	.wrapper {
		width: 100%;
		height: 100%;
		display: flex;

		.left_phone {
			width: 30%;
			height: 100%;
			background: url('@/assets/cloud_bgd.png');

			.master-phone {
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;

				.phone_id_div {
					width: 62%;
					zoom: 2.4 !important;
					padding: 10px 20px;
					background-color: #fff;
					display: flex;
					justify-content: space-between;
					align-items: center;

					span {
						font-weight: 900;
					}
				}
			}

			.master-phone_content {
				zoom: 0.4;

				>div {
					width: initial !important;
					height: initial !important;
				}
			}
		}

		.clouds_id_div {
			width: 40%;
			padding: 5px 10px;
			font-size: 10px;
			background-color: #fff;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-weight: 900;
			}
		}

		/deep/ .device-view {
			display: flex !important;
			flex-direction: row-reverse;
			flex-wrap: nowrap !important;
		}

		/deep/ .control-buttons-list {
			svg {
				width: 84px;
				height: 84px;
			}

			svg:hover {
				cursor: pointer;
			}
		}

		.main_phones {
			width: 70%;
			height: 100%;
			background-color: #f2f3f5;

			.top_btns {
				width: 100%;
				height: 50px;
				background-color: #fff;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0 20px;
				box-sizing: border-box;
				position: relative;
				z-index: 999;

				span {
					height: 32px;
					margin: 0 20px;
					font-size: 14px;
					text-align: center;
					line-height: 32px;
				}

				.Batch_operations {
					margin: 0;
					border: 1px solid #dcdfe6;
					color: #606266;
					border-radius: 10px 0 0 10px;
					padding: 0 10px;
					box-sizing: border-box;
				}

				.Batch_operations:hover {
					background-color: rgb(235.9, 245.3, 255);
					border-color: rgb(197.7, 225.9, 255);
					color: #409eff;
					cursor: pointer;
					outline: none;
				}

				.el-button.el-tooltip__trigger {
					border-left: none;
					padding: 8px 10px;
					border-radius: 0 10px 10px 0;
				}

				>div {
					display: flex;
					align-items: center;
				}
			}
		}

		.no_phone {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			color: #94979e;
		}
	}

	.fun_options {
		p {
			margin: 0;
			padding: 10px 0 10px 20px;
		}

		p:hover {
			background-color: rgb(235.9, 245.3, 255);
			color: #409eff;
			cursor: pointer;
		}
	}

	.slave-screenshot {
		width: 216px;
		height: 384px;
		background: #000;
		border-radius: 6px;
		overflow: hidden;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
	}

	.slave-screenshot-img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.slave-screenshot-placeholder {
		color: #909399;
		font-size: 12px;
	}

	.group-hidden-hosts {
		position: absolute;
		left: -99999px;
		top: -99999px;
		width: 0;
		height: 0;
		overflow: hidden;
		visibility: hidden;
		pointer-events: none;
	}
	.group-hidden-host {
		width: 1080px;
		height: 1920px;
	}
</style>